var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",style:({ textAlign: _vm.center ? 'center' : false })},[_c('div',{staticClass:"lds-ellipsis",class:!_vm.addShadow ? 'lds-ellipsis--noshadow' : ''},[_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }